import '../App.css';

function NoteLegaliPage() {
  const jsonSchemaStructured = {
    "@type": "https://schema.org/WebPage",
    "@id": "#page",
    "url": "",
    "name": "Note Legali",
    "description": "",
    "breadcrumb":
      [
        {
          "@context": "https://schema.org/",
          "@type": "BreadcrumbList",
          "itemListElement":
            [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": {
                  "@id": "https://agenzieux.it/",
                  "name": "Agenzie UX"
                }
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Note Legali",
                "item": {
                  "@id": "https://agenzieux.it/note-legali",
                  "name": "Note Legali"
                }
              }
            ]
        }
      ],
  }
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(jsonSchemaStructured),
        }}
      />
      <div className='font-primary break-words'>
        <h1 className="text-h1 sm:text-h1m font-bold text-left ml-leftBody mr-rightBody mb-6 mt-12">Note legali</h1>

        <h2 className="text-h3 sm:text-h3m font-bold text-left ml-leftBody mr-rightBody mb-6 mt-6">Informazioni in base al § 5 TMG</h2>
        <p className="text-lp mb-6 sm:mb-2 ml-leftBody mr-rightBody">Francesco Gerace</p>
        <p className="text-lp mb-6 sm:mb-2 ml-leftBody mr-rightBody">Via Cesare Giulio Viola 10</p>
        <p className="text-lp mb-6 sm:mb-2 ml-leftBody mr-rightBody">00148 Roma</p>

        <h2 className="text-h3 sm:text-h3m font-bold text-left ml-leftBody mr-rightBody mb-6 mt-6">Kontakt</h2>
        <p className="text-lp mb-6 sm:mb-2 ml-leftBody mr-rightBody">E-Mail: info [@] agenzieux.it</p>
        <p className="text-lp mb-6 sm:mb-2 ml-leftBody mr-rightBody">Non partecipiamo a procedure di risoluzione delle controversie davanti a un collegio arbitrale dei consumatori e non siamo obbligati a farlo.</p>

        <h2 className="text-h3 sm:text-h3m font-bold text-left ml-leftBody mr-rightBody mb-6 mt-6">Responsabile del contenuto ai sensi del § 55 Abs. 2 RStV</h2>
        <p className="text-lp mb-6 sm:mb-2 ml-leftBody mr-rightBody">Francesco Gerace</p>
        <p className="text-lp mb-6 sm:mb-2 ml-leftBody mr-rightBody">Via Cesare Giulio Viola 10</p>
        <p className="text-lp mb-6 sm:mb-2 ml-leftBody mr-rightBody">00148 Roma</p>

        <h2 className="text-h3 sm:text-h3m font-bold text-left ml-leftBody mr-rightBody mb-6 mt-6">Responsabilità per il contenuto</h2>
        <p className="text-lp mb-6 sm:mb-2 ml-leftBody mr-rightBody">In qualità di fornitore di servizi, siamo responsabili dei nostri contenuti su queste pagine, ai sensi dell'articolo 7 (1) TMG (legge tedesca sui media telematici) e della legislazione generale. Ai sensi dei §§ 8-10 TMG, tuttavia, in qualità di fornitore di servizi non siamo obbligati a monitorare le informazioni trasmesse o memorizzate da terzi o a indagare su circostanze che indicano un'attività illegale.</p>
        <p className="text-lp mb-6 sm:mb-2 ml-leftBody mr-rightBody">L'obbligo di rimuovere o bloccare l'uso delle informazioni in conformità alla legislazione generale rimane inalterato. Tuttavia, la responsabilità in questo senso è possibile solo dal momento in cui veniamo a conoscenza di una specifica violazione. Non appena verremo a conoscenza di tali violazioni, provvederemo a rimuovere immediatamente tali contenuti.</p>

        <h2 className="text-h3 sm:text-h3m font-bold text-left ml-leftBody mr-rightBody mb-6 mt-6">Responsabilità per i link</h2>
        <p className="text-lp mb-6 sm:mb-2 ml-leftBody mr-rightBody">Il nostro sito web contiene link a siti esterni di terzi sui cui contenuti non abbiamo alcuna influenza. Pertanto, non ci assumiamo alcuna responsabilità per questi contenuti di terzi. Il rispettivo fornitore o gestore delle pagine è sempre responsabile del contenuto delle pagine collegate. Le pagine collegate sono state controllate per verificare eventuali violazioni di legge al momento del collegamento. I contenuti illegali non erano riconoscibili al momento del collegamento.</p>
        <p className="text-lp mb-6 sm:mb-2 ml-leftBody mr-rightBody">Tuttavia, il monitoraggio permanente del contenuto delle pagine collegate non è ragionevole senza prove concrete di una violazione. Se veniamo a conoscenza di violazioni legali, rimuoveremo immediatamente tali link.</p>

        <h2 className="text-h3 sm:text-h3m font-bold text-left ml-leftBody mr-rightBody mb-6 mt-6">Copyright</h2>
        <p className="text-lp mb-6 sm:mb-2 ml-leftBody mr-rightBody">I contenuti e le opere create dagli operatori del sito su queste pagine sono soggetti alla legge tedesca sul diritto d'autore. La duplicazione, l'elaborazione, la distribuzione e qualsiasi tipo di utilizzo al di fuori dei limiti della legge sul copyright richiedono il consenso scritto del rispettivo autore o creatore. Download e copie di questo sito sono consentiti solo per uso privato e non commerciale.</p>
        <p className="text-lp mb-6 sm:mb-2 ml-leftBody mr-rightBody">Nella misura in cui i contenuti di questo sito non sono stati creati dal gestore, vengono rispettati i diritti d'autore di terzi. In particolare, i contenuti di terzi sono contrassegnati come tali. Se tuttavia doveste venire a conoscenza di una violazione del copyright, vi preghiamo di informarci. Qualora venissimo a conoscenza di violazioni, provvederemo a rimuovere immediatamente tali contenuti.</p>

      </div>
    </>
  );
}

export default NoteLegaliPage;
